export default "__VITE_ASSET__CaALkwhQ__"